export default "__VITE_ASSET__Cmkqc8qm__";